var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F7F7F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_356_550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9375 9.375C13.9375 10.0549 13.7359 10.7195 13.3582 11.2848C12.9805 11.8501 12.4436 12.2907 11.8155 12.5508C11.1874 12.811 10.4962 12.8791 9.82938 12.7464C9.16257 12.6138 8.55007 12.2864 8.06932 11.8057C7.58858 11.3249 7.26119 10.7124 7.12855 10.0456C6.99592 9.37881 7.06399 8.68765 7.32417 8.05953C7.58434 7.4314 8.02494 6.89454 8.59023 6.51682C9.15552 6.13911 9.82013 5.9375 10.5 5.9375C11.4114 5.93853 12.2851 6.30103 12.9295 6.94546C13.574 7.58989 13.9365 8.46364 13.9375 9.375ZM18.625 10C18.625 11.607 18.1485 13.1779 17.2557 14.514C16.3629 15.8502 15.094 16.8916 13.6093 17.5065C12.1247 18.1215 10.491 18.2824 8.9149 17.9689C7.3388 17.6554 5.89106 16.8815 4.75476 15.7452C3.61846 14.6089 2.84463 13.1612 2.53112 11.5851C2.21762 10.009 2.37852 8.37535 2.99348 6.8907C3.60844 5.40605 4.64985 4.1371 5.986 3.24431C7.32214 2.35152 8.89303 1.875 10.5 1.875C12.6542 1.87727 14.7195 2.73403 16.2427 4.25727C17.766 5.78051 18.6227 7.84581 18.625 10ZM17.375 10C17.374 9.07464 17.1864 8.15898 16.8234 7.30778C16.4604 6.45658 15.9295 5.68734 15.2624 5.04604C14.5952 4.40475 13.8056 3.90457 12.9408 3.57544C12.0759 3.2463 11.1536 3.09496 10.2289 3.13047C6.54922 3.27266 3.61485 6.3375 3.625 10.0195C3.62853 11.6957 4.24674 13.3124 5.3625 14.5633C5.8169 13.9042 6.3941 13.339 7.0625 12.8984C7.11949 12.8608 7.18724 12.8429 7.25539 12.8474C7.32353 12.8519 7.38832 12.8786 7.43985 12.9234C8.28921 13.6581 9.37466 14.0624 10.4977 14.0624C11.6207 14.0624 12.7061 13.6581 13.5555 12.9234C13.607 12.8786 13.6718 12.8519 13.7399 12.8474C13.8081 12.8429 13.8758 12.8608 13.9328 12.8984C14.6021 13.3387 15.1801 13.904 15.6352 14.5633C16.7564 13.3078 17.3758 11.6833 17.375 10Z",
    fill: "#93939D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_356_550",
    x: 2.375,
    y: 0.875,
    width: 16.25,
    height: 18.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_356_550"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_356_550",
    result: "effect2_innerShadow_356_550"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.201d9fa541697c848cb6361138f688eb.svg";
export { ForwardRef as ReactComponent };